var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#pablo"}},[_c('span',{staticClass:"no-icon"},[_vm._v("Perfil")])])]),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#pablo"}},[_c('span',{staticClass:"no-icon"},[_vm._v("Cerrar sesión")])])])])
}]

export { render, staticRenderFns }